$(document).ready(function(){

	// -- open/close menu
	$('.menuBtn').on('click', function(){
		$('body').toggleClass('mainMenu--open');
		$(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
		$(this).attr('aria-haspopup', $(this).attr('aria-haspopup') === 'true' ? 'false' : 'true');
	});

	// -- close menu when click outside --
	$(document).on('mouseup', function(e) {
	  var container = $('.header');
	  var innerElements = $('.header__banners, .header__banner, .header__topbar, .header__partners');
	  if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('body').removeClass('mainMenu--open');
	  }
	  if (innerElements.is(e.target) || innerElements.has(e.target).length === 1) {
	  	$('body').removeClass('mainMenu--open');
	  }
	});

});



$(document).on('scroll resize orientationchange', function(){
	// -- Header fixed --
	var scrollTop = $(this).scrollTop();
	var navbar = $('.header__navbar').outerHeight();
	if (scrollTop > navbar) {
		$('body').addClass('navbar--fixed');
	} else {
		$('body').removeClass('navbar--fixed');
	}

});